<template>
    <div class="bg-black m-0">
        <CContainer>
            <CRow>
                <CCol sm="12">
    
                    <CRow>
                        <CCol sm="6">
                            <div class="custom-40px-600 text-left mt-5"><img src="../assets/img/logowhite.png" width="100px" /></div>
                        </CCol>
                        <CCol sm="2">
                            <div class="text-left">
                                <h3 class="custom-16px-600 text-white mt-3">Company</h3>
    
    
                                <h4 class="custom-16px-400 font-color-98A2B3 text-left">Our Mission</h4>

                                <h4 class="custom-16px-400 font-color-98A2B3 text-left">Our Vision</h4>
                                <h4 class="custom-16px-400 font-color-98A2B3 text-left">Our Story</h4>
                                <h4 class="custom-16px-400 font-color-98A2B3 text-left">Meet Our Team</h4>
                            </div>
                        </CCol>
                        <CCol sm="2">
                            <h3 class="m-3 custom-16px-600 text-white">Resources</h3>

                                <h4 class="custom-16px-400 font-color-98A2B3 text-left">Blog</h4>
                                <h4 class="custom-16px-400 font-color-98A2B3 text-left">Case Studies</h4>
                                <h4 class="custom-16px-400 font-color-98A2B3 text-left">Guide</h4>
                        </CCol>
                        <CCol sm="2">
                            <h3 class="m-3 custom-16px-600 text-white">Contact Us</h3>

                                <h4 class="custom-16px-400 font-color-98A2B3 text-left"><img src="../assets/img/iconmap.png" width="20px"/></h4>
                                <h4 class="custom-16px-400 font-color-98A2B3 text-left"><img src="../assets/img/iconemail.png" width="20px"/></h4>
                                <h4 class="custom-16px-400 font-color-98A2B3 text-left"><img src="../assets/img/iconphone.png" width="20px"/></h4>
                        </CCol>
                    </CRow>
    
                    <br />
    
    
                </CCol>
    
    
    
            </CRow>
        </CContainer>
        <hr />
        <CRow>
            <CCol sm="6"><label class="m-3 font-color-171717">© 2024 MyVisionX All rights reserved.</label></CCol>
            <CCol sm="6">
                <div class="text-right"><label class="m-3 font-color-171717">Privacy Policy</label
              >
    
              <label class="m-3 font-color-171717"  @click="GoToLegal()"
                >Terms and Conditions</label
              >
    
              <label class="m-3 font-color-171717"
                >Cookie Policy</label
              >
            </div> </CCol>
        </CRow>
      </div>
</template>

<script>
export default {
    name: "TheFooter",
    data() {
        return {

        };
    },
    methods: {
        GoToAbout() {
            this.$router.push("About");
        },
        GoToContact() {
            this.$router.push("ContactUs");
        },
        GoToLegal() {
            this.$router.push("Legal");
        },
        GoToBlog() {
            this.$router.push("Blog");
        },
        GoToLegal() {
            this.$router.push("Legal");
        },
        GoToLinkedIn() {
            window.open("https://www.linkedin.com/company/70999536/");
        },
        GoToFacebook() {
            window.open("https://www.facebook.com/pickiddo");
        },
        GoToInstagram() {
            window.open("https://www.instagram.com/pickiddo");
        },
        GoToTiktok() {
            window.open("https://www.tiktok.com/@pickiddo");
        },
        GoToYoutube() {
            window.open("https://www.youtube.com/@pickiddo");
        },
        GoToWhatsapp() {
            window.open("https://wa.me/600106597700");
        },

        changeImageSrc() {
            // Change image source to hover image source
            this.imageSrc = this.hoverImageSrc;
        },
        resetImageSrc() {
            // Reset image source to original image source
        },
        changeImageSrcInsta() {
            // Change image source to hover image source
            this.imageSrcInsta = this.hoverImageSrcInsta;
        },
        resetImageSrcInsta() {
            // Reset image source to original image source
        },
        changeImageSrcFb() {
            // Change image source to hover image source
            this.imageSrcFb = this.hoverImageSrcFb;
        },
        resetImageSrcFb() {
            // Reset image source to original image source
        },
        changeImageSrcLn() {
            // Change image source to hover image source
            this.imageSrcLn = this.hoverImageSrcLn;
        },
        resetImageSrcLn() {
            // Reset image source to original image source
        },
        changeImageSrcWs() {
            // Change image source to hover image source
            this.imageSrcWs = this.hoverImageSrcWs;
        },
        resetImageSrcWs() {
            // Reset image source to original image source
        },
        changeImageSrcYou() {
            // Change image source to hover image source
            this.imageSrcYou = this.hoverImageSrcYou;
        },
        resetImageSrcYou() {
            // Reset image source to original image source
        },
    },
};
</script>

<style>
.pointer:hover {
    cursor: pointer;
    text-decoration: underline;
}

.hover-pointer1 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.hover-pointer2 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.hover-pointer3 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.hover-pointer4 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.hover-pointer5 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.hover-pointer6 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
</style>
  

